import { Injectable } from '@angular/core';
import { LocalDbService } from '../local-db-service';
import { User } from '../../entities/user';

@Injectable({ providedIn: 'root' })
export class UserRepository {
  private get table() {
    return this.db.userTable;
  }

  constructor(private readonly db: LocalDbService) {}

  async getByEmail(email: string): Promise<User | undefined> {
    const row = await this.table.get(email);
    if (!row) return undefined;
    const user = new User(row.id, row.email, row.name);
    user.pushEndpoint = row.pushEndpoint;
    return user;
  }

  upsert(user: User): Promise<string> {
    return this.table.put(user);
  }

  upsertBulk(users: User[]): Promise<string> {
    return this.table.bulkPut(users);
  }

  clear(): Promise<void> {
    return this.table.clear();
  }

  async setEndpoint(email: string, endpoint: string): Promise<void> {
    const user = await this.getByEmail(email);
    if (!user) return;
    user.pushEndpoint = endpoint;
    await this.upsert(user);
}
}